import { put, call, takeLatest } from 'redux-saga/effects'
import { request, processErr } from '../api/request'
import * as actions from '../actions/wall'
import {
    GET_USER_REQUEST,
    GET_TRANSACTION_LIST_REQUEST,
} from '../constant/actionTypes'

const urlUser = '/user'
const urlTransaction = '/transaction'

const getUserApi = payload => {
    const email = payload

    return request().get(`${urlUser}/target?email=${email}`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const getTransactionListApi = payload => {
    const uid = payload

    return request().get(`${urlTransaction}/list?status=1&uid=${uid}`)
        .then(res => {
            if (res.status === 200) {
                return res.data
            }
        })
        .catch(err => { throw processErr(err) })
}

function* getUserRequest(action) {
    try {
        const data = yield call(getUserApi, action.payload)
        yield put(actions.getUserSuccess(data))
    } catch (e) {
        yield put(actions.getUserFailure(e))
    }
}

function* getTransactionListRequest(action) {
    try {
        const data = yield call(getTransactionListApi, action.payload)
        yield put(actions.getTransactionListSuccess(data))
    } catch (e) {
        yield put(actions.getTransactionListFailure(e))
    }
}


const wall = [
    takeLatest(GET_USER_REQUEST, getUserRequest),
    takeLatest(GET_TRANSACTION_LIST_REQUEST, getTransactionListRequest)
]

export default wall